// 猫眼图训练库[108张]
const cateyesGallery = function cateyes_list() {
  const arr = []
  for (let i = 1; i < 109; i++) {
    arr.push(
      `https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/gallery/%E7%8C%AB%E7%9C%BC%E5%9B%BE%E5%BA%93/maoyan%20(${i}).jpg`
    )
  }
  // console.log(arr)
  return arr
}
// 黑手图训练库[50张]
const balckhandsGallery = function blackhands_list() {
  const arr = []
  for (let i = 1; i < 51; i++) {
    arr.push(
      `https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/gallery/%E9%BB%91%E6%89%8B%E5%9B%BE%E5%BA%93/black_hands%20(${i}).png`
    )
  }
  // console.log(arr)
  return arr
}
// 猫眼SDXL[25张]
const cateyessdxl = function cateyesxl_list() {
  const arr = []
  for (let i = 1; i < 26; i++) {
    arr.push(
      `https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/gallery/%E7%8C%AB%E7%9C%BC%E5%9B%BE%E5%BA%93XL/maoyanxl%20(${i}).jpg`
    )
  }
  // console.log(arr)
  return arr
}
// 大杂烩训练库[49张]
const commonsdxl = function common_list() {
  const arr = []
  for (let i = 1; i < 50; i++) {
    arr.push(
      `https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/gallery/%E5%A4%A7%E6%9D%82%E7%83%A9/dazahui%20(${i}).png`
    )
  }
  // console.log(arr)
  return arr
}
// 通用美甲训练库[766张]
const commonflux = function commonflux_list() {
  const arr = []
  for (let i = 1; i < 767; i++) {
    arr.push(
      `https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/gallery/%E9%80%9A%E7%94%A8%E5%9B%BE%E5%BA%93/commonmj%20(${i}).png`
    )
  }
  // console.log(arr)
  return arr
}

const num = 108

export default { cateyesGallery, num, balckhandsGallery, cateyessdxl, commonsdxl, commonflux }
